var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{ 'wp-button-add-list mt-4': _vm.visible }},[_c('Transition',{attrs:{"name":"slide"}},[(_vm.show)?_c('WPButton',{on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default")],2):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }